<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post19-khargisland-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post19-khargisland-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.80487804878049;"
    data-aspect-ratio="0.805"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post19-khargisland-xs-img"
      class="g-post19-khargisland-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-khargisland-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:10.1417%;margin-top:-14.6px;left:67.6773%;width:114px;"
    >
      <p class="g-pstyle1">Genaveh-Kharg</p>
      <p class="g-pstyle1">pipeline</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.2922%;margin-top:-7.5px;left:5.9979%;width:84px;"
    >
      <p class="g-pstyle2">Kharg Island</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.2637%;margin-top:-14.6px;left:38.498%;margin-left:-38.5px;width:77px;"
    >
      <p class="g-pstyle3">US/Israel</p>
      <p class="g-pstyle3">attacks</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.2595%;margin-top:-7.7px;left:31.7414%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle0">Kharg Island</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post19-khargisland-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.93406593406593;"
    data-aspect-ratio="0.934"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post19-khargisland-sm-img"
      class="g-post19-khargisland-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-khargisland-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.5083%;margin-top:-16.5px;left:41.7798%;width:120px;"
    >
      <p class="g-pstyle1">Genaveh-Kharg</p>
      <p class="g-pstyle1">pipeline</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:26.1213%;margin-top:-6.6px;left:88.6029%;margin-left:-65px;width:130px;"
    >
      <p class="g-pstyle2">US/Israel attacks</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.3304%;margin-top:-8.7px;left:14.0763%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle3">Kharg Island</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.0512%;margin-top:-9px;left:82.1258%;width:89px;"
    >
      <p class="g-pstyle0">Kharg Island</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post19-khargisland-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.21546961325967;"
    data-aspect-ratio="1.215"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post19-khargisland-md-img"
      class="g-post19-khargisland-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-khargisland-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:10.5045%;margin-top:-9px;left:80.5821%;width:89px;"
    >
      <p class="g-pstyle1">Kharg Island</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.6579%;margin-top:-6.6px;left:85.5871%;margin-left:-65px;width:130px;"
    >
      <p class="g-pstyle2">US/Israel attacks</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:43.7687%;margin-top:-8.7px;left:15.8715%;width:111px;"
    >
      <p class="g-pstyle3">Kharg Island</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.0028%;margin-top:-16.5px;left:45.1632%;width:120px;"
    >
      <p class="g-pstyle0">Genaveh-Kharg</p>
      <p class="g-pstyle0">pipeline</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post19-khargisland-lg"
    class="g-artboard"
    style="min-width: 930px;max-width: 1199px;aspect-ratio: 1.5;"
    data-aspect-ratio="1.5"
    data-min-width="930"
    data-max-width="1199"
  >
    <div
      id="g-post19-khargisland-lg-img"
      class="g-post19-khargisland-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-khargisland-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:40.3873%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:40.3873%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:40.3873%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-post19-khargisland-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 1.93548387096774;"
    data-aspect-ratio="1.935"
    data-min-width="1200"
  >
    <div
      id="g-post19-khargisland-xl-img"
      class="g-post19-khargisland-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-khargisland-xl.jpg);"
    ></div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-17 16:31 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-17 16:31 -->
<!-- ai file: post19-khargisland.ai -->
<style lang="scss">
  #g-post19-khargisland-box {
    container-type: inline-size;
    container-name: g-post19-khargisland-box;
  }
  #g-post19-khargisland-box,
  #g-post19-khargisland-box .g-artboard {
    margin: 0 auto;
  }
  #g-post19-khargisland-box p {
    margin: 0;
  }
  #g-post19-khargisland-box .g-aiAbs {
    position: absolute;
  }
  #g-post19-khargisland-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post19-khargisland-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post19-khargisland-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post19-khargisland-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post19-khargisland-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post19-khargisland-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post19-khargisland-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post19-khargisland-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-post19-khargisland-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post19-khargisland-xl {
        display: block !important;
      }
    }
  }
  #g-post19-khargisland-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-khargisland-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(151, 151, 151);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-khargisland-xs .g-pstyle0 {
    font-weight: 700;
    height: 14px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-post19-khargisland-xs .g-pstyle1 {
    font-weight: 400;
    height: 14px;
  }
  #g-post19-khargisland-xs .g-pstyle2 {
    font-weight: 300;
    height: 14px;
    font-size: 12px;
    color: rgb(0, 0, 0);
  }
  #g-post19-khargisland-xs .g-pstyle3 {
    font-weight: 400;
    height: 14px;
    text-align: center;
    color: rgb(8, 81, 156);
  }
  #g-post19-khargisland-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-khargisland-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(151, 151, 151);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-khargisland-sm .g-pstyle0 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 13px;
    color: rgb(0, 0, 0);
  }
  #g-post19-khargisland-sm .g-pstyle1 {
    font-weight: 400;
    height: 16px;
  }
  #g-post19-khargisland-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    text-align: center;
    color: rgb(8, 81, 156);
  }
  #g-post19-khargisland-sm .g-pstyle3 {
    font-weight: 700;
    height: 16px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-post19-khargisland-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-khargisland-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(151, 151, 151);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-khargisland-md .g-pstyle0 {
    font-weight: 400;
    height: 16px;
  }
  #g-post19-khargisland-md .g-pstyle1 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 13px;
    color: rgb(0, 0, 0);
  }
  #g-post19-khargisland-md .g-pstyle2 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    text-align: center;
    color: rgb(8, 81, 156);
  }
  #g-post19-khargisland-md .g-pstyle3 {
    font-weight: 700;
    height: 16px;
    font-size: 16px;
    color: rgb(64, 64, 64);
  }
  #g-post19-khargisland-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-khargisland-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-khargisland-lg .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-post19-khargisland-lg .g-pstyle1 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post19-khargisland-lg .g-pstyle2 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }
  #g-post19-khargisland-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-khargisland-xl p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-khargisland-xl .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-post19-khargisland-xl .g-pstyle1 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post19-khargisland-xl .g-pstyle2 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  @mixin shadow-emmental($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 1);
    text-shadow:
      -1px 0 rgba($clr, $alpha),
      0 1px rgba($clr, $alpha),
      1px 0 rgba($clr, $alpha),
      0 -1px rgba($clr, $alpha);
  }
  .g-whiteshadow {
    @include shadow-emmental(#ffffff);
  }
</style>
